import { CommonElementType } from "@utils/DynamicComponentUtils";
import {
  CommonContentsRenderType,
  CommonCreateBodyKeyType,
  CommonDataType,
} from "src/types/common";

export type Category = "NORMAL" | "IR" | "ETC";

export interface NoticeCreateInitValuesType {
  category: Category;
  title: string;
  isExposed: boolean;
  isPriorityExposed: boolean;
  postStartAt: string;
  postEndAt: string;
  contentCategory: string;
  content: string;
}

export interface NoticeCommonContentsOptionType
  extends CommonContentsRenderType {
  secondName?: string;
  placeholder?: string;
  secondPlaceholder?: string;
}

export const NoticeCreateData: CommonDataType<
  CommonCreateBodyKeyType,
  NoticeCreateInitValuesType,
  NoticeCommonContentsOptionType
> = {
  createBodyKey: [
    "category",
    "title",
    "isExposed",
    "isPriorityExposed",
    "postStartAt",
    "postEndAt",
    "content",
  ],
  formInitialValues: {
    category: "NORMAL",
    title: "",
    isExposed: false,
    isPriorityExposed: false,
    postStartAt: "",
    postEndAt: "",
    contentCategory: "content",
    content: "",
  },
  contentsOption: [
    {
      label: "게시 유형",
      name: "category",
      type: CommonElementType.RADIO,
      options: [
        { label: "공지(충전서비스)", value: "NORMAL" },
        { label: "투자정보", value: "IR" },
      ],
    },
    {
      label: "게시 기간",
      type: CommonElementType.DATE_RANGE_PICKER,
      name: "postStartAt",
      secondName: "postEndAt",
      placeholder: "날짜를 입력해주세요",
      secondPlaceholder: "날짜를 입력해주세요",
    },
    {
      label: "노출 상태",
      name: "isExposed",
      type: CommonElementType.TOGGLE,
    },
    {
      label: "상단 고정 여부",
      name: "isPriorityExposed",
      type: CommonElementType.TOGGLE,
    },
    {
      label: "제목",
      name: "title",
      type: CommonElementType.INPUT,
      placeholder: "제목을 입력해주세요",
    },
  ],
};
